/**
 * Cart Drawer Web Component
 */

// serialize function is now loaded globally from form-serialize.js

// Ensure Shopify.formatMoney is available. Some stores do not load Shopify's
// legacy currency script, which leaves Shopify.formatMoney undefined and causes
// the cart drawer success handler to throw. Define a compatible implementation
// only if one is not already present.
window.Shopify = window.Shopify || {};
if (typeof window.Shopify.formatMoney !== 'function') {
	window.Shopify.formatMoney = function (cents, format) {
		if (typeof cents === 'string') {
			cents = cents.replace('.', '');
		}
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = format || window.moneyFormat || '\u20AC{{amount_with_comma_separator}}';

		function defaultTo(num, precision, thousands, decimal) {
			precision = (typeof precision === 'number' && precision >= 0) ? precision : 2;
			thousands = (typeof thousands === 'string') ? thousands : ',';
			decimal = (typeof decimal === 'string') ? decimal : '.';

			if (isNaN(cents) || cents == null) {
				return 0;
			}

			cents = (cents / 100.0).toFixed(precision);

			var parts = cents.split('.');
			var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
			var centsAmount = parts[1] ? (decimal + parts[1]) : '';

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = defaultTo(2, ',', '.');
				break;
			case 'amount_no_decimals':
				value = defaultTo(0, ',', '.');
				break;
			case 'amount_with_comma_separator':
				value = defaultTo(2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = defaultTo(0, '.', ',');
				break;
			case 'amount_with_space_separator':
				value = defaultTo(2, ' ', ',');
				break;
			case 'amount_no_decimals_with_space_separator':
				value = defaultTo(0, ' ', '');
				break;
			case 'amount_with_apostrophe_separator':
				value = defaultTo(2, "'", '.');
				break;
			default:
				value = defaultTo(2, ',', '.');
				break;
		}

		return formatString.replace(placeholderRegex, value);
	};
}

class CartDrawerComponent extends HTMLElement {
	constructor() {
		super();
		
		this.errorCodes = [
			400, 401, 402, 403.404, 405, 406, 409, 414, 415, 422, 423, 430, 500, 501,
			502, 503, 504, 530, 540, 783,
		];
		
		this.dialog = null;
		this.isInitialized = false;
		this.scrollPosition = 0;
	}

	connectedCallback() {
		if (this.isInitialized) return;
		this.isInitialized = true;
		
		this.dialog = new A11yDialog(this.querySelector(".cart__drawer-wrap"));

		this.dialog.on('show', () => {
			setTimeout(() => {
				document.body.classList.add("cart-drawer--open")
			}, 150);
		});
		
		// Listen to A11yDialog events to handle scroll position
		this.dialog.on('hide', () => {
			document.body.classList.remove("cart-drawer--open")
			// Restore scroll position when dialog is fully hidden
			setTimeout(() => {
				window.scrollTo(0, this.scrollPosition);
			}, 10);
		});
		
		// Add a safety mechanism to ensure scroll lock is cleaned up
		this.dialog.on('hide', () => {
			// Force unlock scroll lock after a delay to ensure it's cleaned up
			setTimeout(() => {
				if(this.scrollLock && this.scrollLock.hasAttribute('active')) {
					console.warn('Scroll lock was not properly cleaned up, forcing unlock');
					this.scrollLock.forceUnlock();
					this.scrollLock.removeAttribute('active');
				}
			}, 500);
		});
		
		// Initialize if URL hash is #cart
		if (window.location.hash === '#cart') {
			this.open();
		}
		
		// Add data attribute event listeners
		this.setupDataAttributeListeners();
		
		// Add keyboard event listeners
		this.setupKeyboardListeners();
	}

	get cartDrawerWrap() {
		return this.querySelector(".cart__drawer-wrap");
	}

	get cartDrawer() {
		return this.querySelector(".cart__drawer");
	}

	get cartItems() {
		return this.querySelector(".cart__drawer-items");
	}

	get bag() {
		return document.querySelector("[data-bag-count]");
	}

	get bagSr() {
		return document.querySelectorAll("[data-bag-count-sr]");
	}

	get checkoutButton() {
		return document.querySelector(".cart__drawer-footer-checkout");
	}

	get checkoutButtonTextEl() {
		return document.querySelector(".cart__drawer-footer-checkout span");
	}

	get scrollLock() {
		return document.querySelector('scroll-lock');
	}

	/**
	 * Dispatch custom cart events
	 * @param {string} eventName - Event name (cart-added, cart-updated, cart-error)
	 * @param {*} data - Data to pass with event
	 */
	dispatchCartEvent(eventName, data) {
		const event = new CustomEvent(eventName, { 
			detail: data,
			bubbles: true 
		});
		document.dispatchEvent(event);
	}

	/**
	 * Sets up event listeners for data attributes to control cart drawer
	 */
	setupDataAttributeListeners() {
		// Listen for clicks on elements with data-cart-open attribute
		document.addEventListener('click', (event) => {
			const target = event.target.closest('[data-cart-open]');
			if (target) {
				event.preventDefault();
				this.open();
			}
		});

		// Listen for clicks on elements with data-cart-close attribute
		document.addEventListener('click', (event) => {
			const target = event.target.closest('[data-cart-close]');
			if (target) {
				event.preventDefault();
				this.close();
			}
		});

	}

	/**
	 * Sets up keyboard event listeners for cart drawer
	 */
	setupKeyboardListeners() {
		// Listen for escape key to close cart
		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape' && this.isOpen()) {
				event.preventDefault();
				this.close();
			}
		});
	}

	/**
	 * Check if the cart drawer is currently open
	 * @returns {boolean} True if cart is open
	 */
	isOpen() {
		return this.cartDrawerWrap && this.cartDrawerWrap.classList.contains("active");
	}

	updateCartContents(data) {
		console.log(data);
		if(data.sections && data.sections["cart-drawer-v2"]){
			const parser = new DOMParser();
			const cartHTML = parser.parseFromString(data.sections["cart-drawer-v2"], "text/html");					
			this.cartDrawer.innerHTML = cartHTML.querySelector(".cart__drawer").innerHTML;
		}
		if(data.item_count !== undefined){
			if(data.item_count > 0){
				if(document.querySelector("#CartCount") !== null){
					document.querySelector("#CartCount").style.display = "flex";
				}
			} else {
				if(document.querySelector("#CartCount") !== null){
					document.querySelector("#CartCount").style.display = "none";
				}
			}
		} else {
			if(data.quantity > 0){
				if(document.querySelector("#CartCount") !== null){
					document.querySelector("#CartCount").style.display = "flex";
				}
			} else {
				if(document.querySelector("#CartCount") !== null){
					document.querySelector("#CartCount").style.display = "none";
				}
			}
		}
	}
	
    /**
     * Refreshes the slide out cart drawer's content using fetch()
     * @returns {(Promise|Object)} Returns the cart's json and then returns the cart object
     */
	updateBagCounts() {
		fetch(`${window.Shopify.routes.root}cart.js`, {
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest'
			}
		}).then(response => {
			return response.json();
		}).then(cart => {
			// console.log(cart)
			if (cart.item_count > 0) {
				if (this.bag) {
					this.bag.textContent = cart.item_count;
				}		
			} else {
				if (this.bag) {
					this.bag.textContent = "0";
				}			
			}
			// Dispatch extra custom event to signal that the cart has been updated 
			// window.addEventListener('cartUpdated', (event) => { ... }
			const cartUpdatedEvent = new CustomEvent('cartUpdated', { detail: cart });
			window.dispatchEvent(cartUpdatedEvent);			
		})
	}
    /**
     * OPEN CART // Opens the slide out cart by adding the class "active" to the $cartDrawerWrap element
     */ 
	open() {
		// Save current scroll position before opening
		this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

		// Set scroll lock BEFORE showing dialog to prevent any scroll issues
		if(this.scrollLock){
			this.scrollLock.setAttribute('active', '');
		}
		
		this.dialog.show();
		this.cartDrawerWrap.classList.add("active");
	}
    /**
     * CLOSE CART // Closes the slide out cart by removing the class "active" to the $cartDrawerWrap element
     */ 
	close() {
		this.dialog.hide();
		if (this.cartDrawerWrap.classList.contains("active")) {
			this.cartDrawerWrap.classList.remove("active")
		}
		
		// Remove scroll lock AFTER dialog is hidden to ensure proper cleanup
		if(this.scrollLock){
			// Use setTimeout to ensure the dialog hide animation completes
			setTimeout(() => {
				this.scrollLock.removeAttribute('active');
			}, 100);
		}
	}

	/**
     * REFRESH THE CART // Refreshes the cart by fetching the cart.js file
     * @param  {String} form_id  The ID of the form to submit
     * @returns {(Promise|Function)} Returns the cart's json and then returns runs updateBagCounts() and showCart()
     * @example window.refreshCart(); return false;
     */ 
	refreshCart() {
		fetch(`${window.Shopify.routes.root}cart.js`, {
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest'
			}
		}).then(response => {
			return response.json();
		}).then(cart => {
			this.updateCartContents(cart);
		});
	}

    /**
     * ADD ITEM TO THE CART // Submits a product form via fetch() and the product to the slide out cart
     * @param  {String} form_id  The ID of the form to submit
     * @returns {(Promise|Function)} Returns the cart's json and then returns runs updateBagCounts() and showCart()
     * @example window.addToCart('add-to-cart'); return false;
     */ 
	addToCart(form_id) { 
		if (this.checkoutButton) {
			this.checkoutButton.setAttribute("disabled", true)
			this.checkoutButtonTextEl.textContent = window.checkoutUpdatingButtonText;
		}
		if(document.getElementById(form_id) !== null && document.getElementById(form_id).querySelector("[data-button-atc-text]") !== null){
			document.getElementById(form_id).querySelector("[data-button-atc-text]").disabled = true;
			document.getElementById(form_id).querySelector("[data-button-atc-text]").textContent = window.addToCartLoadingButtonText;
		}
		const formData = serialize(document.getElementById(form_id), { hash: true });

		console.log(formData);

		fetch(`${window.Shopify.routes.root}cart/add.js`, {
			body: JSON.stringify({
				...formData,
				sections: "cart-drawer-v2"
			}),
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest'
			},
			method: 'POST'
		}).then(response => {
			return response.json();
		}).then((data) => {

			this.updateCartContents(data);

			if (data.status !== undefined && this.errorCodes.includes(data.status)) {
				alert(data.description);
				this.dispatchCartEvent('cart-error', data);
			} else {
				// KLAVIYO PRODUCT TRACKING
				var _learnq = window._learnq || [];
				var kl = {
					Name: `${data.product_title}`,
					ProductID: `${data.id}`,
					ImageURL: `${data.image}`,
					URL: `${window.location.origin}${data.url}`,
					Brand: `${data.vendor}`,
					Price: `${Shopify.formatMoney(data.final_price)}`,
					CompareAtPrice: `${Shopify.formatMoney(data.original_price)}`,
					VariantTitle: `${data.variant_title}`,
					VariantPrice: `${Shopify.formatMoney(data.final_price)}`,
					VariantImage: `${data.image}`,
					VariantSKU: `${data.sku}`,
					VariantID: `${data.variant_id}`,
					VariantOption1: `${data.variant_options[0] ? data.variant_options[0] : ""}`,
					VariantOption2: `${data.variant_options[1] ? data.variant_options[1] : ""}`,
					VariantOption3: `${data.variant_options[2] ? data.variant_options[2] : ""}`
				};
				_learnq.push(['track', 'Added to Cart', kl]);		
				console.log(`KL Added to Cart`, kl)			
				this.updateBagCounts()
				
				// Dispatch cart-added event
				this.dispatchCartEvent('cart-added', data);
				
				if(document.getElementById(form_id) !== null && document.getElementById(form_id).querySelector("[name='add']") !== null){
					document.getElementById(form_id).querySelector("[name='add']").disabled = false;
					document.getElementById(form_id).querySelector("[name='add']").classList.remove("disabled");
					document.getElementById(form_id).querySelector("[name='add']").classList.remove("loading");
				}

				if(document.getElementById(form_id) !== null && document.getElementById(form_id).querySelector("[data-button-atc-text]") !== null){
					document.getElementById(form_id).querySelector("[data-button-atc-text]").textContent = window.addToCartAddedButtonText;
				}
				setTimeout(() => {	
					if(document.getElementById(form_id) !== null && document.getElementById(form_id).querySelector("[data-button-atc-text]") !== null){
						document.getElementById(form_id).querySelector("[data-button-atc-text]").disabled = false;
					}
					setTimeout(() => {
						this.open()
					}, 150);
					setTimeout(() => {				
						if(document.getElementById(form_id) !== null && document.getElementById(form_id).querySelector("[data-button-atc-text]") !== null){
							document.getElementById(form_id).querySelector("[data-button-atc-text]").textContent = window.addToCartButtonText;
						}
					}, 500);
				}, 300);
			}
		})
	}

	/**
	 * ADD MULTIPLE FORM'S ITEMS TO THE CART // Submits multiple product forms via fetch() and adds the products to the slide-out cart
	 * @param  {Array} form_ids  Array of form IDs to submit
	 * @returns {(Promise|Function)} Returns the cart's json and then runs updateBagCounts() and showCart()
	 * @example window.addAllToCart(['add-to-cart', 'add-to-cart-2']); return false;
	 */ 
	addAllToCart(form_ids) {
		if (this.checkoutButton) {
			this.checkoutButton.setAttribute("disabled", true);
			this.checkoutButtonTextEl.textContent = window.checkoutUpdatingButtonText;
		}
	
		// Gather items from each form
		const items = form_ids.map(form_id => serialize(document.getElementById(form_id), { hash: true }));
	
		fetch(`${window.Shopify.routes.root}cart/add.js`, {
			body: JSON.stringify({ 
				...items,
				sections: "cart-drawer-v2"
			}),
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest'
			},
			method: 'POST'
		})
		.then(response => response.json())
		.then((data) => {

			this.updateCartContents(data);

			if (data.status !== undefined && this.errorCodes.includes(data.status)) {
				alert(data.description);
			}
			// KLAVIYO PRODUCT TRACKING for each item
			data.items.forEach(item => {
				var _learnq = window._learnq || [];
				var kl = {
					Name: `${item.product_title}`,
					ProductID: `${item.id}`,
					ImageURL: `${item.image}`,
					URL: `${window.location.origin}${item.url}`,
					Brand: `${item.vendor}`,
					Price: `${Shopify.formatMoney(item.final_price)}`,
					CompareAtPrice: `${Shopify.formatMoney(item.original_price)}`,
					VariantTitle: `${item.variant_title}`,
					VariantPrice: `${Shopify.formatMoney(item.final_price)}`,
					VariantImage: `${item.image}`,
					VariantSKU: `${item.sku}`,
					VariantID: `${item.variant_id}`,
					VariantOption1: `${item.variant_options[0] || ""}`,
					VariantOption2: `${item.variant_options[1] || ""}`,
					VariantOption3: `${item.variant_options[2] || ""}`
				};
				_learnq.push(['track', 'Added to Cart', kl]);
			});
		
			this.updateBagCounts();
			this.open();
		});
	}	

	/**
	 * Updates a cart's item by variant ID and quantity via fetch().
	 * @param  {String} variantId The ID of the variant to update.
	 * @param  {Number} qty The quantity to update to.
	 * @returns {Promise<void>} Updates the cart and refreshes the cart view.
	 */
	cartItemUpdate(variantId, qty) {
		const formData = new URLSearchParams();
		formData.append(`updates[${variantId}]`, qty);

		if (this.checkoutButton) {
			this.checkoutButton.setAttribute("disabled", true);
			this.checkoutButtonTextEl.textContent = window.checkoutUpdatingButtonText;
		}

		fetch(`${window.Shopify.routes.root}cart/update.js`, {
			method: 'POST',
			headers: {
				'X-Requested-With': 'xmlhttprequest',
				'Content-Type': 'application/x-www-form-urlencoded', // Ensure proper content type
			},
			body: formData.toString() + '&sections=cart-drawer-v2', // Append sections to formData
		})
			.then((response) => {
				if (!response.ok) {
					console.error(`Error: ${response.status} - ${response.statusText}`);
					throw new Error(`Failed to update cart: ${response.statusText}`);
				}
				return response.json();
			})
			.then((data) => {

				this.updateCartContents(data);

				if (data.status !== undefined && this.errorCodes.includes(data.status)) {
					alert(data.description);
					this.dispatchCartEvent('cart-error', data);
				} else {
					this.announceCartItemUpdate(data.item_count);
					this.updateBagCounts();
					this.dispatchCartEvent('cart-updated', data);
					this.open();
				}
			})
			.catch((error) => {
				console.error('Cart update failed:', error);
				setTimeout(() => {
					this.updateBagCounts();
					this.open();
				}, 750); // Fallback to refresh the cart after a delay
			})
			.finally(() => {
				if (this.checkoutButton) {
					this.checkoutButton.removeAttribute("disabled");
					this.checkoutButtonTextEl.textContent = window.checkoutButtonText;
				}
			});
	}

   /**
    * ANNOUNCE CART ITEM UPDATE // Announces cart item update to screen readers
    */
   announceCartItemUpdate(qty) {

    // Create a visually hidden element to announce the update
    var updateAnnouncement = document.createElement('div');
    updateAnnouncement.textContent = 'Cart item quantity updated to ' + qty;
    updateAnnouncement.setAttribute('role', 'alert');
    updateAnnouncement.setAttribute('aria-live', 'polite');
    updateAnnouncement.setAttribute('aria-atomic', 'true');
    updateAnnouncement.style.position = 'absolute';
    updateAnnouncement.style.left = '-9999px';
    updateAnnouncement.style.width = '1px';
    updateAnnouncement.style.height = '1px';
    updateAnnouncement.style.overflow = 'hidden';
    
    // Append the announcement element to the document body
    document.body.appendChild(updateAnnouncement);
    
    // Remove the announcement element after a short delay
    setTimeout(function() {
      document.body.removeChild(updateAnnouncement);
    }, 1000); // Adjust the delay as needed

   }
}

// Register the custom element
customElements.define('cart-drawer', CartDrawerComponent);

// Global functions for backward compatibility
let cartDrawerInstance = null;

// Set up global functions immediately - they'll work once cart drawer is ready
window.updateBagCounts = (() => {
	if (cartDrawerInstance) {
		cartDrawerInstance.updateBagCounts();
	} else {
		waitForEl('cart-drawer').then(instance => {
			cartDrawerInstance = instance;
			cartDrawerInstance.updateBagCounts();
		});
	}
});

window.addToCart = ((form_id) => {
	if (cartDrawerInstance) {
		cartDrawerInstance.addToCart(form_id);
	} else {
		waitForEl('cart-drawer').then(instance => {
			cartDrawerInstance = instance;
			cartDrawerInstance.addToCart(form_id);
		});
	}
});

window.addAllToCart = ((form_ids) => {
	if (cartDrawerInstance) {
		cartDrawerInstance.addAllToCart(form_ids);
	} else {
		waitForEl('cart-drawer').then(instance => {
			cartDrawerInstance = instance;
			cartDrawerInstance.addAllToCart(form_ids);
		});
	}
});

window.cartItemUpdate = ((variantId, qty) => {
	if (cartDrawerInstance) {
		cartDrawerInstance.cartItemUpdate(variantId, qty);
	} else {
		waitForEl('cart-drawer').then(instance => {
			cartDrawerInstance = instance;
			cartDrawerInstance.cartItemUpdate(variantId, qty);
		});
	}
});

window.showCart = (() => {
	if (cartDrawerInstance) {
		cartDrawerInstance.open();
	} else {
		waitForEl('cart-drawer').then(instance => {
			cartDrawerInstance = instance;
			cartDrawerInstance.open();
		});
	}
});

window.closeCart = (() => {
	if (cartDrawerInstance) {
		cartDrawerInstance.close();
	} else {
		waitForEl('cart-drawer').then(instance => {
			cartDrawerInstance = instance;
			cartDrawerInstance.close();
		});
	}
});